<div class="row mb-3">
  <div class="col-12">
    <sb-card>
      <div card-body>
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <h3>{{'lang.reporting.shareOfVoice' | translate}}</h3>
            <h5>{{from.toString() | date : 'dd.MM.yyyy'}} - {{till.toString() | date : 'dd.MM.yyyy'}}</h5>
          </div>
          <div class="d-flex justify-content-center align-items-center">
            <div *ngIf="eleId" class="mr-2">
              <button class="btn btn-info" (click)="selectElement(null)">
                <sb-icon icon="pieChartStake"></sb-icon>&nbsp;{{'lang.globals.overview' | translate}}
              </button>
            </div>
            <sb-boolean-toggles class="d-flex justify-content-between align-items-center mr-2"
                                [toggles]="initialBooleans" (toggleChange)="playoutSwitch()">
            </sb-boolean-toggles>

            <sb-local-date-range-input class="mr-2" [from]="from" [till]="till" [showSubmit]="false"
                                       (dateChange)="handleDateChange($event)"></sb-local-date-range-input>
            <sb-comp-dropdown-select *ngPermissions="permissionService.Permission.cull_list" [showSubmit]="true"
                                     [inputData]="culls" [dropDownDatatype]="'PLAYER_CULLS'"
                                     (selectedDataEmitter)="update($event, 'PLAYER_CULLS')" [showColumnIcon]="false"
                                     [msOptions]="msCullOptions" (msOptionsChange)="msRequest('PLAYER_CULLS', $event)"
                                     [selectedInputData]="filteredCulls">
            </sb-comp-dropdown-select>
            <sb-button (click)="refresh()" [disabled]="loading" [loading]="loading"
                       classes="glow btn-primary mr-0">{{'lang.reporting.getData' | translate}}</sb-button>

          </div>
        </div>
      </div>
    </sb-card>
  </div>
</div>
<div *ngIf="initLoad && !loading" class="d-flex justify-content-center">
  <div class="d-flex align-items-end">
    <div style="margin-bottom: 15px; margin-left: 10px">
      <sb-button (click)="refresh()" [disabled]="loading" [loading]="loading" classes="glow btn-primary mr-0">
        {{'lang.reporting.getData' | translate}}</sb-button>
    </div>
  </div>
</div>
<div *ngIf="noDataFound && !loading" class="d-flex justify-content-center">
  <div class="d-flex align-items-end">
    <img height="280" src="./assets/img/notFoundWhitelabel.png"/>
    <div style="margin-bottom: 15px; margin-left: 10px">
      <h1>{{'lang.globals.noDataFound' | translate}}</h1>
      <h4>{{'lang.reporting.noDataDescription' | translate}}</h4>
    </div>
  </div>
</div>

<sb-comp-share-of-voice-overview [playoutsNumber]="playoutsNumber" [selectedField]="selectedField?.id" [@slideInOut]
                                 [loading]="loading" (selectedElement)="selectElement($event)" *ngIf="!eleId && !noDataFound && !initLoad"
                                 [reportingObj]="overviewData" [additionalReportingObj]="additionalMediumGroupData" [from]="from"
                                 [till]="till">
</sb-comp-share-of-voice-overview>
<app-share-of-voice-content [playoutsNumber]="playoutsNumber" [selectedField]="selectedField?.id" [@slideInOut]
                            *ngIf="eleId && !noDataFound && !initLoad" [from]="from" [till]="till" [loading]="loading"
                            [reportingObj]="reportingObj">
</app-share-of-voice-content>
<!--<h1 *ngIf="loading">Loading...</h1>-->

<ng-container *sbPageAction>
  <div class="d-flex">
    <div *ngIf="!eleId" ngbDropdown container="body" class="d-inline-block mr-2">
      <button [disabled]="loading" class="btn btn-outline-primary" ngbDropdownToggle>{{selectedField ?
        selectedField.name : 'lang.globals.select'|translate}}&nbsp;
        <sb-icon style="font-size: 0.5rem" icon="chevronDown"></sb-icon>
      </button>
      <div ngbDropdownMenu>
        <ul class="dropdown">
          <li class="item" *ngFor="let field of fieldsToSelect">
            <a (click)="selectField(field)" ngbDropdownItem>
              {{field.name}}
            </a>
          </li>
        </ul>

      </div>
    </div>
    <!--
    <div ngbDropdown container="body" class="d-inline-block mr-2">
      <button [disabled]="loading" class="btn btn-outline-primary" ngbDropdownToggle>select</button>
      <div ngbDropdownMenu style="width: 500px;">
        <div class="px-3">
          <input type="text" class="form-control my-2" placeholder="{{'lang.globals.searchPlaceholder' | translate}}" [(ngModel)]="eleSearch">
        </div>
        <hr>
        <ng-scrollbar style="height: 300px;">
          <table>
            <tr (click)="selectEle(ele)" ngbDropdownItem *ngFor="let ele of possibleElements | filter:eleSearch">
              <td>
                <sb-preview-tooltip [previews]="[ele?.preview]"></sb-preview-tooltip>
              </td>
              <td>
                {{ele?.name}}
              </td>
            </tr>
          </table>
        </ng-scrollbar>
       <div class="px-3" sb-pagination *ngIf="paginationElementsInitialized" [collectionSize]="collectionSizeElements" [(page)]="pageElements"
            (pageChange)="pageChangeElements($event)" [maxSize]="maxSizeElements" [boundaryLinks]="false" [showPageSize]="false"></div>
      </div>
    </div
    <div class="mr-2">
      <div id="from-box" (click)="changeFrom()" class="cursor-pointer btn btn-outline-primary">
        &nbsp;&nbsp;{{getFrom()}} &nbsp;<fa-icon [icon]="'chevron-up'"></fa-icon>
      </div>
    </div>
    <div class="mr-2">
      <div id="till-box" (click)="changeTill()" class="cursor-pointer btn btn-outline-primary">
        &nbsp;&nbsp;{{getTill()}} &nbsp;<fa-icon [icon]="'chevron-up'"></fa-icon>
      </div>
    </div>

    <sb-button (click)="refresh()" [disabled]="loading" [loading]="loading" classes="glow btn-primary mr-0">Get data</sb-button>>-->
  </div>

</ng-container>
